import { useMemo } from 'react';
import { PageHeader } from '../../layouts/Shells';
import { useAuth } from '../auth/AuthProvider';
import { createScoreApi } from './scoreboardApi';
import { createScoreV3Api } from './scoreboardV3Api';
import { ScoreboardTabs } from './ScoreboardTabs';

export function MarketingScoreboardPage() {
  const { client, access } = useAuth();
  const api = useMemo(() => createScoreApi(client), [client]);
  const v3 = useMemo(() => createScoreV3Api(client), [client]);
  // The route also uses RequireTap. The database is the final authorization
  // boundary; can_edit, not internal_role alone, controls section editors.
  if (
    access.status !== 'approved' ||
    !access.profile.is_active ||
    access.profile.account_type !== 'tap'
  )
    return null;
  return (
    <>
      <PageHeader title="Marketing Scoreboard" topbar />
      <ScoreboardTabs key={access.profile.id} cacheScope={access.profile.id} api={api} v3={v3} />
    </>
  );
}
